import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const COLORS = ['#94c840', '#f5b719', '#34beaa', '#744c9d'];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = (props: any) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, title, link } = props;
    const radius = innerRadius + ((outerRadius - innerRadius) * 0.5);
    const x = cx + (radius * Math.cos(-midAngle * RADIAN));
    const y = cy + (radius * Math.sin(-midAngle * RADIAN));
    const horizontal = (midAngle === 90 || midAngle === 270);

    return (
        <foreignObject
            x={horizontal ? x - 100 : x - 60}
            y={y - 50}
            width={horizontal ? 200 : 125}
            height={100}
            fontSize={18}
            fill="#424746"
            textAnchor={x > cx ? 'start' : 'end'}
            dominantBaseline="central"
            fontWeight={700}
        >
            <a
                href={link.url}
                style={{ color: '#424746', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <p
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{ textAlign: 'center', whiteSpace: 'pre-wrap', margin: '0' }}
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            </a>
        </foreignObject>
    );
};

export class ResponseWheel extends PureComponent {

    render() {
        const { entries = [] } = this.props;
        const data = entries
            .map((entry, index) => ({ ...entry, value: index % 2 === 0 ? 200 : 100 }));


        return (
            <div>
                <PieChart width={540} height={540}>
                    <Pie
                        data={[{ title: '#mtocovid19 response', value: 1 }]}
                        outerRadius={85}
                        fill="#dcddde"
                        stroke="transparent"
                        labelLine={false}
                        label={({ title }) => (
                            <foreignObject
                                x={170}
                                y={245}
                                width={200}
                                height={50}
                                fontSize={18}
                                textAnchor="central"
                                dominantBaseline="central"
                                fontWeight={700}
                            >
                                <p xmlns="http://www.w3.org/1999/xhtml" style={{ textAlign: 'center', color: '#744b9d' }}>
                                    {title}
                                </p>
                            </foreignObject>
                        )}
                    />
                    <Pie
                        data={data}
                        innerRadius={105}
                        outerRadius={150}
                        startAngle={30}
                        endAngle={390}
                        strokeWidth={4}
                        labelLine={false}
                    >
                        {
                            data.map((entry, index) =>
                                <Cell key={`${entry.title}-${index}`} fill={COLORS[index % COLORS.length]} />)
                        }
                    </Pie>
                    <Pie
                        data={data}
                        innerRadius={150}
                        outerRadius={270}
                        fill="#dcddde"
                        startAngle={30}
                        endAngle={390}
                        strokeWidth={4}
                        labelLine={false}
                        label={renderCustomizedLabel}
                    />
                </PieChart>

                <svg width="0" height="0">
                    <filter id="reponse-wheel-shadow" height="130%">
                        <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
                        <feOffset dx="4" dy="4" result="offsetblur" />
                        <feComponentTransfer>
                            <feFuncA type="linear" slope="0.5" />
                        </feComponentTransfer>
                        <feMerge>
                            <feMergeNode />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </svg>
            </div>
        );
    }
}
